import React from 'react';
import {Helmet} from "react-helmet";
import ContactsComponent from "../../../components/ContactsComponent";
import icon from '../../../assets/images/icons8-file-64.png'

const FundamentalsPage = () => {

  const subjects = ['Фундаментальная информатика', 'Языки и методы программирования', 'Операционные системы', 'Фундаментальные алгоритмы', 'Разработка IT-проектов', 'Методы оптимизации', 'Криптография', 'Искусственный интеллект', 'Компьютерные сети', 'Разработка Web-приложений'];

  const description = "Студенты направления 02.03.02 'Фундаментальная информатика и информационные технологии' получают глубокие и обширные знания, охватывающие различные области, включая прикладную математику, общетеоретическую информатику и инновационные информационные технологии. Они могут применять свои навыки в разнообразных сферах.";
  const keywords = "02.03.02, Фундаментальная информатика, Информационные технологии, прикладная математика, общетеоретическая информатика, инновационные информационные технологии, интеллектуальные системы, вычислительные технологии, компьютерные науки, технологии баз данных, компьютерная графика, теория информации, управление информационно-коммуникационными системами, бизнес-процессы, архитектура программного обеспечения, параллельные вычисление, распределенные вычисление";

  return (
      <div className="container">
        <Helmet>
          <meta name="description" content={description} />
          <meta name="keywords" content={keywords} />
        </Helmet>
        <h1>02.03.02</h1>
        <h1>Фундаментальная информатика и информационные технологии</h1>
        <div className="content">
          <h3>О направлении</h3>
          <div className='highlight-content'>
          <p className="section-text">
            Студенты направления 02.03.02 "Фундаментальная информатика и информационные технологии" получают глубокие и обширные знания, охватывающие различные области, включая прикладную математику, общетеоретическую информатику и инновационные информационные технологии. Это обеспечит выпускникам возможность применять свои навыки в разнообразных сферах, включая интеллектуальные системы, вычислительные технологии, компьютерные науки, технологии баз данных, компьютерную графику, теорию информации, управление информационно-коммуникационными системами и бизнес-процессами, архитектуру программного обеспечения, параллельное и распределенное вычисление.
          </p>
          </div>
          <h3>Основные дисциплины</h3>
          <div className='highlight-content'>
            <p className="section-text">
              <ul>
                {subjects.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
              </ul>
            </p>

            <div>
              <a href="https://itmai.ru/storage/02_03_02_806.pdf" target="_blank" rel="noopener noreferrer" style={{color: '#007acd', textDecoration: 'none', display: 'flex', alignItems: 'center'}}>
                <img src={icon} style={{height: '40px', marginRight: '10px'}} alt="file icon" />
                <p style={{margin: 0}}>Учебный план 02.03.02 "Фундаментальная информатика и информационные технологии" (каф. 806)</p>
              </a>
            </div>

          </div>
          <h3>Проходные баллы 2023 года</h3>
          <div className='highlight-content'>
            <p className="section-text">
              Проходной балл (балл последнего зачисленного) — <span style={{color: '#007acd', fontWeight: 'bold'}}>257</span>.
            </p>
            <p className="section-text">
              Проходной балл с общежитием — <span style={{color: '#007acd', fontWeight: 'bold'}}>260</span>.
            </p>
            <p className="section-text">
              Проходной балл целевого приема — <span style={{color: '#007acd', fontWeight: 'bold'}}>181</span>.
            </p>
            <p className="section-text">
              Средний балл поступивших по общему конкурсу — <span style={{color: '#007acd', fontWeight: 'bold'}}>263</span>.
            </p>
            <p className="section-text">
              Проходной балл на платную основу — <span style={{color: '#007acd', fontWeight: 'bold'}}>200</span>.
            </p>
          </div>
        </div>
      </div>
  );
};

export default FundamentalsPage;